export default "__VITE_ASSET__DU5gjqy2__"